export const IMPORT_TYPES = [
  { id: "personnel", label: "Personel Listesi", desc: "Ad Soyad, Görev, Telefon, TC, Maaş, Sigorta, İşe Başlama", sample: "Ad Soyad · Görev · Telefon · TC · Maaş · Sigorta" },
  { id: "milk",      label: "Süt Üretim Geçmişi", desc: "Tarih, Litre, Birim Fiyat, Sağılan Hayvan Sayısı", sample: "Tarih · Litre · Birim Fiyat · Hayvan Sayısı" },
  { id: "stock",     label: "Stok Kalemleri", desc: "İsim, Kategori, Birim, Miktar, Birim Fiyat, Sayım Periyodu, Tedarikçi", sample: "İsim · Kategori · Birim · Miktar · Fiyat" },
];
